<template>
  <div>
    <md-card>
      <md-card-content class="md-layout">
        <p class="md-layout-item md-size-100 pb-4 p-0">
          {{ $t("extended_exportation.roster_title") }}
        </p>
        <div class="md-layout-item md-size-30 pl-0">
          <md-field>
            <label>{{ $t("class.term") }}</label>
            <md-select v-model="termSelected">
              <md-option
                v-for="option in termList"
                :value="option.id"
                :key="option.id + option.name"
                >{{ option.name }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-30">
          <checkbox-multi-select
            label="class.filter_by_teacher"
            :options="teacherList"
            v-model="teachersSelected"
            :showSelectAll="true"
          ></checkbox-multi-select>
        </div>

        <p class="md-layout-item md-size-100 pl-0">
          {{ $t("extended_exportation.enrollment_status_title") }}
        </p>
        <div class="md-layout-item md-size-30 pl-0 pt-2">
          <checkbox-multi-select
            label="extended_exportation.enrollment_status"
            :options="enrollmentStatusList"
            v-model="enrollmentStatusSelected"
            :showSelectAll="true"
          ></checkbox-multi-select>
        </div>
        <p class="md-layout-item md-size-100 pl-0">
          {{ $t("extended_exportation.display_options") }}
        </p>
        <div class="md-layout-item md-size-33 md-small-size-100 pl-0">
          <md-checkbox v-model="periodSelected"
            >{{ $t("extended_exportation.period_schedule") }}
          </md-checkbox>
          <md-checkbox v-if="periodSelected" v-model="studySelected"
            >{{ $t("extended_exportation.studying_location") }}
          </md-checkbox>
        </div>
      </md-card-content>
    </md-card>
    <div class="flex justify-center pt-2">
      <md-button class="md-warning md-round" @click="exportPDF()"
        >{{ $t("communication.send_email") }}
      </md-button>
    </div>
  </div>
</template>

<script>
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
import { getId, Message } from "@/helpers/utils";
import { service_names, service_paths } from "@/constants/Services";

export default {
  components: { CheckboxMultiSelect },
  data() {
    return {
      termSelected: "",
      termList: [],
      teachersSelected: [],
      teacherList: [],
      enrollmentStatusSelected: ["Active", "Inactive", "withdrawal"],
      enrollmentStatusList: [
        { id: "Active", name: this.$t("common.active") },
        { id: "Inactive", name: this.$t("common.inactive") },
        { id: "withdrawal", name: this.$t("student.withdrawal") }
      ],
      periodSelected: false,
      studySelected: false
    };
  },
  created() {
    this.fetchTermOpts();
  },
  watch: {
    periodSelected: function(periodSelected) {
      if (!periodSelected) {
        this.studySelected = false;
      }
    },
    termSelected: function(termId) {
      this.teachersSelected = [];
      this.fetchTeacherOptsByTerm(termId);
    }
  },
  methods: {
    fetchTermOpts() {
      this.$axios
        .get(service_paths.terms, { order_by: "created_at DESC", limit: 100 })
        .then(response => {
          this.termList = response.data.data.map(term => ({
            id: term.id,
            name: term.name
          }));
          this.termSelected = this.termList[0].id;
        });
    },
    fetchTeacherOptsByTerm(termId) {
      this.$axios
        .get(`${service_names.school}/user/${termId}/teacher-assignment`, {
          limit: 20
        })
        .then(response => {
          this.teacherList = response.data.map(teacher => {
            return {
              id: getId(teacher),
              name: teacher?.user_no_sql.full_name
            };
          });
        });
    },
    async exportPDF() {
      let dataRosterReport = {
        term_id: this.termSelected,
        teacher_ids: this.teachersSelected,
        is_display_period_schedule: this.periodSelected,
        is_display_studying_location: this.studySelected,
        enrollment_status: this.enrollmentStatusSelected
      };
      if (
        this.enrollmentStatusSelected.length === 3 ||
        this.enrollmentStatusSelected.length === 0
      ) {
        dataRosterReport.enrollment_status = ["All"];
      }
      if (dataRosterReport.teacher_ids.length === 0) {
        delete dataRosterReport.teacher_ids;
      }
      await this.$axios
        .post(`${service_paths.export}/roster-report/pdf`, dataRosterReport)
        .then(response => {
          if (response.status === 200) {
            Message.success(
              this.$t("extended_exportation.export_file_successfully")
            );
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .checkbox-multi-selections label {
  display: block;
  margin: -3px 0;
  color: #aaa;
  font-weight: 400;
}
</style>
